import React, { createContext, useContext } from "react";

interface ILoadingProvider {
  children: React.ReactNode;
}

interface ILoadingContext {
  loading: boolean;
  setLoading: (value: boolean) => void;
}

const LoadingContext = createContext<ILoadingContext>({
  loading: false,
  setLoading: (_value: boolean) => {},
});

export const useLoading = () => useContext(LoadingContext);

const LoadingProvider: React.FC<ILoadingProvider> = ({ children }: ILoadingProvider) => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const toggleLoading = (value: boolean): void => {
    setLoading(value);
  };

  return <LoadingContext.Provider value={{ loading, setLoading: toggleLoading }}>{children}</LoadingContext.Provider>;
};

export default LoadingProvider;
